import { Avatar, AvatarProps, LinkProps, styled, SxProps } from '@mui/material';
import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';
import React from 'react';

const SelectableIconButtonBase = styled(Avatar)<AvatarProps>(({ theme }) => ({
  ...theme.typography.commonAvatar,
  ...theme.typography.mediumAvatar,
  overflow: 'hidden',
  transition: 'all .2s ease-in-out',
}));

interface SelectableIconButtonProps extends AvatarProps, Pick<LinkProps, 'href' | 'target'> {
  selected?: boolean;
  href?: string;
  disabled?: boolean;
}
const SelectableIconButtonComponent = (
  {
    sx = {},
    selected = false,
    href = undefined,
    children,
    disabled = false,
    onClick,
    ...rest
  }: SelectableIconButtonProps,
  ref: React.Ref<HTMLDivElement>,
) => {
  const { mode } = useConfig();

  return (
    <SelectableIconButtonBase
      ref={ref}
      sx={
        [
          {
            bgcolor: mode === ThemeMode.DARK ? 'dark.main' : 'secondary.light',
            color: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
            '&:hover': {
              bgcolor: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
              color: mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.light',
              '& *': {
                color: mode === ThemeMode.DARK ? 'secondary.light !important' : 'secondary.light !important',
              },
            },
            ...(selected && {
              bgcolor: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
              color: mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.light',
              '& *': {
                color: mode === ThemeMode.DARK ? 'secondary.light !important' : 'secondary.light !important',
              },
            }),
            fontSize: 13,
            width: 'auto',
            minWidth: 34,
            px: 0.625,
            gap: 0.5,
            ...(disabled && {
              opacity: 0.5,
              pointerEvents: 'none',
              cursor: 'default',
            }),
          },
          sx,
        ] as SxProps
      }
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      {children}
    </SelectableIconButtonBase>
  );
};

const SelectableIconButton = React.forwardRef(SelectableIconButtonComponent);

export default SelectableIconButton;
